
/* ALPHX Find Your Fit — waist + thigh only (no preference)
   Version: 2025-10-28c
*/
(function () {
  // ---------- helpers ----------
  const WR = (min, max) => ({ min, max });
  const inRange = (v, min, max) => v >= min && v <= max;
  const ORDER = ["XS","S","M","L","XL","XXL"];
  const sizeIndex = s => ORDER.indexOf(s);
  const sizeUp = s => ORDER[Math.min(ORDER.length - 1, sizeIndex(s) + 1)];

  // ---------- data (inches) ----------
  const BOXER_BRIEF = {
    label: "Boxer Briefs",
    slug: "mens-premium-boxer-briefs",
    fits: {
      Modern: {
        XS: { waist: WR(25,27), thighRelax:[14.0,18.0], thighMax:19.0 },
        S:  { waist: WR(28,30), thighRelax:[15.5,20.0], thighMax:20.0 },
        M:  { waist: WR(31,33), thighRelax:[17.0,22.0], thighMax:22.5 },
        L:  { waist: WR(34,37), thighRelax:[18.0,23.5], thighMax:24.0 },
        XL: { waist: WR(38,41), thighRelax:[19.0,24.5], thighMax:25.0 },
        XXL:{ waist: WR(42,45), thighRelax:[21.0,25.0], thighMax:27.0 },
      },
      Athletic: {
        // XS, XXL not available
        S:  { waist: WR(28,30), thighRelax:[16.5,21.0], thighMax:22.5 },
        M:  { waist: WR(31,33), thighRelax:[17.5,23.5], thighMax:24.0 },
        L:  { waist: WR(34,37), thighRelax:[18.0,24.5], thighMax:25.0 },
        XL: { waist: WR(38,41), thighRelax:[19.0,26.5], thighMax:27.0 },
      }
    }
  };

  const TRUNKS = {
    label: "Trunks",
    slug: "alphx-comfort-class-trunks",
    fits: {
      Modern: {
        XS: { waist: WR(25,27), thighRelax:[18.0,19.5], thighMax:24.0 },
        S:  { waist: WR(28,30), thighRelax:[19.0,21.5], thighMax:25.0 },
        M:  { waist: WR(31,33), thighRelax:[20.0,24.0], thighMax:26.0 },
        L:  { waist: WR(34,37), thighRelax:[21.0,26.0], thighMax:28.0 },
        XL: { waist: WR(38,41), thighRelax:[22.0,29.0], thighMax:30.0 },
        XXL:{ waist: WR(42,45), thighRelax:[21.0,31.0], thighMax:32.0 },
      },
      Athletic: {
        // XS, XXL not available
        S:  { waist: WR(28,30), thighRelax:[20.0,23.0], thighMax:27.0 },
        M:  { waist: WR(31,33), thighRelax:[21.0,26.0], thighMax:28.0 },
        L:  { waist: WR(34,37), thighRelax:[22.0,28.0], thighMax:30.0 },
        XL: { waist: WR(38,41), thighRelax:[19.0,30.5], thighMax:31.5 },
      }
    }
  };

  const BRIEFS = {
    label: "Briefs",
    slug: "modern-briefs",
    fits: {
      Modern: {
        XS: { waist: WR(25,27), thighRelax:[19.0,23.0], thighMax:25.0 },
        S:  { waist: WR(28,30), thighRelax:[21.0,27.0], thighMax:29.0 },
        M:  { waist: WR(31,33), thighRelax:[20.0,29.0], thighMax:31.0 },
        L:  { waist: WR(34,37), thighRelax:[21.0,31.0], thighMax:33.0 },
        XL: { waist: WR(38,41), thighRelax:[22.0,33.0], thighMax:35.0 },
        XXL:{ waist: WR(42,45), thighRelax:[21.0,36.0], thighMax:38.0 },
      }
    }
  };

  const CATALOG = [BOXER_BRIEF, TRUNKS, BRIEFS];

  // ---------- core logic ----------
  function baseSizeByWaist(style, waist) {
    // choose the smallest size whose waist range contains the value
    let pick = null;
    for (const fitName of Object.keys(style.fits)) {
      const fit = style.fits[fitName];
      for (const size of Object.keys(fit)) {
        const { min, max } = fit[size].waist;
        if (inRange(waist, min, max)) {
          if (!pick || sizeIndex(size) < sizeIndex(pick)) pick = size;
        }
      }
    }
    return pick;
  }

  function fitConfig(style, fitName, size) {
    return style.fits[fitName] && style.fits[fitName][size] ? style.fits[fitName][size] : null;
  }

  function pickFit(style, size, thigh) {
    const m = fitConfig(style, "Modern", size);
    const a = fitConfig(style, "Athletic", size);

    // 1) Prefer Modern relaxed if it fits
    if (m && inRange(thigh, m.thighRelax[0], m.thighRelax[1])) {
      return { size, fit: "Modern", note: null };
    }

    // 2) Else prefer Athletic relaxed (same size) if available
    if (a && inRange(thigh, a.thighRelax[0], a.thighRelax[1])) {
      return { size, fit: "Athletic", note: null };
    }

    // 3) If thigh above Athletic relaxed (or Athletic not available), size up until Athletic relaxed fits
    if (a && thigh > a.thighRelax[1]) {
      let s = size;
      while (true) {
        const next = sizeUp(s);
        if (next === s) break; // at top
        const nextA = fitConfig(style, "Athletic", next);
        if (nextA && inRange(thigh, nextA.thighRelax[0], nextA.thighRelax[1])) {
          return { size: next, fit: "Athletic", note: null };
        }
        s = next;
      }
      // If never found relaxed but <= max of the upsized Athletic, allow with note
      s = size;
      while (true) {
        const next = sizeUp(s);
        if (next === s) break;
        const nextA = fitConfig(style, "Athletic", next);
        if (nextA && thigh <= nextA.thighMax) {
          return { size: next, fit: "Athletic", note: "Approaches Max Stretch; consider more room if preferred." };
        }
        s = next;
      }
    }

    // 4) If Athletic missing for this size (XS/XXL) and Modern relaxed fails, try sizing up Modern
    if (m && thigh > m.thighRelax[1]) {
      let s = size;
      while (true) {
        const next = sizeUp(s);
        if (next === s) break;
        const nextM = fitConfig(style, "Modern", next);
        if (nextM && inRange(thigh, nextM.thighRelax[0], nextM.thighRelax[1])) {
          return { size: next, fit: "Modern", note: "Sized up for thigh comfort." };
        }
        s = next;
      }
      // As last resort, allow Max Stretch
      s = size;
      while (true) {
        const next = sizeUp(s);
        if (next === s) break;
        const nextM = fitConfig(style, "Modern", next);
        if (nextM && thigh <= nextM.thighMax) {
          return { size: next, fit: "Modern", note: "Approaches Max Stretch; consider more room if preferred." };
        }
        s = next;
      }
    }

    // 5) If thigh is *below* Modern relaxed min, Modern/base is still fine (more support).
    if (m && thigh < m.thighRelax[0]) {
      return { size, fit: "Modern", note: null };
    }

    // Fallback (should be rare)
    return null;
  }

  function recommend(style, waist, thigh) {
    // Briefs → Modern only; size up if needed
    if (style === BRIEFS) {
      let size = baseSizeByWaist(style, waist);
      if (!size) return null;
      const m = fitConfig(style, "Modern", size);
      if (inRange(thigh, m.thighRelax[0], m.thighRelax[1])) {
        return { size, fit: "Modern", note: null };
      }
      // size up until relaxed fits or max is acceptable
      let s = size;
      while (true) {
        const next = sizeUp(s);
        if (next === s) break;
        const nm = fitConfig(style, "Modern", next);
        if (nm && inRange(thigh, nm.thighRelax[0], nm.thighRelax[1])) {
          return { size: next, fit: "Modern", note: "Sized up for thigh comfort." };
        }
        s = next;
      }
      s = size;
      while (true) {
        const next = sizeUp(s);
        if (next === s) break;
        const nm = fitConfig(style, "Modern", next);
        if (nm && thigh <= nm.thighMax) {
          return { size: next, fit: "Modern", note: "Approaches Max Stretch; consider more room if preferred." };
        }
        s = next;
      }
      return null;
    }

    // Boxer Briefs / Trunks
    const base = baseSizeByWaist(style, waist);
    if (!base) return null;
    const pick = pickFit(style, base, thigh);
    return pick;
  }

  // ---------- UI (no Fit Preference) ----------
  const mount = document.getElementById("fit-questionnaire");
  if (!mount) return;

  mount.innerHTML = `
    <label for="q-style">Which style are you shopping?</label>
    <select id="q-style">
      ${CATALOG.map(s=>`<option value="${s.label}">${s.label}</option>`).join("")}
    </select>

    <label for="q-waist">Your waist size (inches)</label>
    <select id="q-waist">
      <option value="">Select...</option>
      ${Array.from({length:21},(_,i)=>25+i).map(n=>`<option>${n}</option>`).join("")}
    </select>

    <label for="q-thigh">Upper thigh circumference (inches)</label>
    <select id="q-thigh">
      <option value="">Select...</option>
      ${Array.from({length:31},(_,i)=>14+i).map(n=>`<option>${n}</option>`).join("")}
    </select>

    <button id="q-submit" type="button">GET MY FIT</button>
  `;

  const getVal = id => document.getElementById(id).value;
  const setText = (id, t) => (document.getElementById(id).textContent = t);

  const loading = document.getElementById("fit-loading");
  const result  = document.getElementById("fit-result");
  const fitType = document.getElementById("fit-type");
  const fitStyle= document.getElementById("fit-style");
  const link    = document.getElementById("shop-link");

  document.getElementById("q-submit").addEventListener("click", () => {
    const styleLabel = getVal("q-style");
    const waist = parseFloat(getVal("q-waist"));
    const thigh = parseFloat(getVal("q-thigh"));
    if (!styleLabel || isNaN(waist) || isNaN(thigh)) return;

    loading.style.display = "block";
    result.style.display  = "none";

    setTimeout(() => {
      const style = CATALOG.find(s => s.label === styleLabel);
      const rec = recommend(style, waist, thigh);

      loading.style.display = "none";
      result.style.display  = "block";

      if (!rec) {
        setText("fit-type", "We couldn’t find a perfect match in that exact size.");
        setText("fit-style", "Try the next size up for more thigh room.");
        link.textContent = `Shop All ${style.label}`;
        link.href = `/collections/${style.slug}`;
        return;
      }

      setText("fit-type", `${style.label}: ${rec.fit} Fit`);
      setText("fit-style", `Recommended size: ${rec.size}${rec.note ? " — " + rec.note : ""}`);
      link.textContent = `Shop ${style.label} in ${rec.size}`;
      link.href = `/collections/${style.slug}`;
    }, 200);
  });

  // version flag
  window.__FITMATRIX_VERSION__ = '2025-10-28c';
  console.log('ALPHX fitMatrix loaded:', window.__FITMATRIX_VERSION__);
})();